/**
 * Create MediaQueryList using breakpoint name
 * @param {string} breakpointName
 * @return {MediaQueryList|null}
 */
export default () => {
    // const themeFunctionality = window.themeFunctionality;
    const breakpointSizes = {
        small: 40,
        medium: 48,
        large: 60,
        widescreen: 90,
    };

    function mediaQueryListFactory(breakpointName) {
        if (!breakpointName || !window.matchMedia) {
            return null;
        }

        const breakpoint = breakpointSizes[breakpointName];
        const mediaQuery = `(min-width: ${breakpoint}em)`;
        return window.matchMedia(mediaQuery);
    }

    window.mediaQueryListFactory = mediaQueryListFactory;
    const mediaQueryList = {
        small: mediaQueryListFactory('small'),
        medium: mediaQueryListFactory('medium'),
        large: mediaQueryListFactory('large'),
        widescreen: mediaQueryListFactory('widescreen'),
    };

    // window.themeFunctionality.mediaQueryList = mediaQueryList;

    return mediaQueryList;
};
